<template>
  <section class="z-[1] relative h-[calc(100vh-400px)] lg:h-[calc(100vh-105px)] bg-gradient-to-t from-black/70 via-black/30 to-black/20 lg:to-transparent py-8 lg:py-20">
    <div class="h-full flex flex-col justify-end max-w-7xl container-padding mx-auto">
      <div class="relative flex flex-col justify-end px-6 py-4 border-l-[4px] border-secondary z-[1]">
        <h1 class="text-2xl lg:text-5xl text-white font-extrabold mb-4">
          About Us
        </h1>

        <p class="text-base lg:text-xl font-medium text-white m-0 w-full max-w-100">
          Great sporting photos reminds us not just
          of what we achieved but also of who we
          became along the way.
        </p>
      </div>

      <!-- Background image -->
      <img
        loading="lazy"
        src="@/assets/images/components/about-banner/banner.webp"
        alt="About Us page banner"
        class="absolute w-full h-full inset-0 object-cover mix-blend-multiply"
      >
    </div>
  </section>
</template>

<script setup>

</script>
